var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "single-column",
    [
      _c("div", { staticClass: "va-title" }, [
        _vm._v(_vm._s(_vm.$t("trial.title")))
      ]),
      _c(
        "v-stepper",
        {
          model: {
            value: _vm.step,
            callback: function($$v) {
              _vm.step = $$v
            },
            expression: "step"
          }
        },
        [
          _c(
            "v-stepper-header",
            [
              _c(
                "v-stepper-step",
                { attrs: { complete: _vm.step > 1, step: 1 } },
                [_vm._v(" " + _vm._s(_vm.$t("trial.steps.os")) + " ")]
              ),
              _c(
                "v-stepper-step",
                { attrs: { complete: _vm.step > 2, step: 2 } },
                [_vm._v(" " + _vm._s(_vm.$t("trial.steps.requirements")) + " ")]
              ),
              _c(
                "v-stepper-step",
                { attrs: { complete: _vm.step > 3, step: 3 } },
                [_vm._v(" " + _vm._s(_vm.$t("trial.steps.download")) + " ")]
              ),
              _c(
                "v-stepper-step",
                { attrs: { complete: _vm.step > 4, step: 4 } },
                [_vm._v(" " + _vm._s(_vm.$t("trial.steps.activate")) + " ")]
              )
            ],
            1
          ),
          _c(
            "v-stepper-items",
            [
              _c(
                "v-stepper-content",
                { attrs: { step: 1 } },
                [
                  _c("trial-step-os", {
                    on: {
                      select: function($event) {
                        _vm.selectedOs = $event
                      },
                      next: _vm.nextStep
                    }
                  })
                ],
                1
              ),
              _c(
                "v-stepper-content",
                { attrs: { step: 2 } },
                [
                  _vm.selectedOs === "android"
                    ? _c("trial-step-requirements-android", {
                        on: { next: _vm.nextStep, prev: _vm.prevStep }
                      })
                    : _vm._e(),
                  _vm.selectedOs === "windows"
                    ? _c("trial-step-requirements-windows", {
                        on: { next: _vm.nextStep, prev: _vm.prevStep }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-stepper-content",
                { attrs: { step: 3 } },
                [
                  _vm.selectedOs === "android"
                    ? _c("trial-step-download-android", {
                        on: { next: _vm.nextStep, prev: _vm.prevStep }
                      })
                    : _vm._e(),
                  _vm.selectedOs === "windows"
                    ? _c("trial-step-download-windows", {
                        on: { next: _vm.nextStep, prev: _vm.prevStep }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-stepper-content",
                { attrs: { step: 4 } },
                [_c("trial-step-activate", { on: { prev: _vm.prevStep } })],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }